module.exports = __webpack_public_path__ + "static/media/20210409_191616_611_IMG_0057.d2f4149b.jpg";